import { useState, useEffect, useMemo } from 'react';
import Axios from "axios";
import { Searchfilter } from '../apiconstants/constants.js';
import { Link, useNavigate } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner.js';
import ConsultantLayout from '../commonlayouts/consultantlayout.js';
import * as pdfjsLib from "pdfjs-dist";
import { useCountry } from "../contexts/countrycodecontext.js";
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;


function substring_str(str) {
  if ((str === null) || (str === ' ' || str === undefined))
    return "";
  else
    str = str.toString();
  return str.substring(0, 100) + "...";
}

const ViewMatchedInternalCandidates = () => {
  const navigate = useNavigate();
    const updatedDate = localStorage.getItem("updatedDateFilter");
  const jobRoleId = localStorage.getItem("jobRoleID");
  const jobPostID = localStorage.getItem("jobPostID");

  const [offset, setOffset] = useState(0);
  const [data, setData] = useState([]);
  const [perPage] = useState(25);
  const [pageCount, setPageCount] = useState(0);
  const [candidateData, setCandidateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const [startDate, setStartDate] = useState(""); // Start date state
  const [endDate, setEndDate] = useState(""); // End date state
  const [showIcon, setShowIcon] = useState('list');
  const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
   const [selectedCards, setSelectedCards] = useState(
     JSON.parse(localStorage.getItem('selectedCandidates')) || []
   );
   const [isAllSelected, setIsAllSelected] = useState(false);
    const {selectedCountry}=useCountry();
    console.log(selectedCountry)
    let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const token = localStorage.getItem("jwtToken");
const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}
  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage * perPage);
  };
  const handleViewToggle = (type) => {
    setViewType(type);
    setShowIcon(type)
  };
  const handleSearch = (e) => {
  setSearchTerm(e.target.value.toLowerCase());
};

useEffect(() => {
  setOffset(0); // when search term changes
}, [searchTerm]);

const GetCandidateList = async () => { 
  setIsLoading(true)
  try {
    const payload = {
      json: JSON.stringify({ UserGuid: Guid ,jobRoleId: jobRoleId,CountryID:selectedCountry,updatedDate:updatedDate}),
      type: "candidatepool",
    };

    const result = await Axios.post(Searchfilter.APIURL, payload,
      { headers: { 'Authorization': `Bearer $(token)`} }
    ); // ✅ Await the Axios call
    setIsLoading(false)
      return Array.isArray(result.data) ? result.data : []; // safety fallback
  } catch (error) {
    console.error("❌ Error fetching candidates:", error);
    setIsLoading(false);
  }
};
useEffect(() => {
  const fromEmailPage = localStorage.getItem('fromSendEmailPage');
  const SelectedInternalCandidates = JSON.parse(localStorage.getItem('SelectedInternalCandidates') || '[]');

  const fetchAndRestore = async () => {
    const data = await GetCandidateList();
    if (!data || data.length === 0) {
      setCandidateData([]);
      setSelectedCards([]);
      return;
    }

    setCandidateData(data);

    if (fromEmailPage === 'true' && SelectedInternalCandidates.length > 0) {
      const selectedEmails = SelectedInternalCandidates.map(c => c.email);
      const restored = data.filter(candidate =>
        selectedEmails.includes(candidate.email)
      );
      setSelectedCards(restored);
    }
  };

  fetchAndRestore();
  localStorage.removeItem('fromSendEmailPage');
}, []);

const filteredCandidates = useMemo(() => {
  const lowerSearchTerm = searchTerm?.toLowerCase()?.trim();
  if (!lowerSearchTerm) return candidateData || [];

  let searchTerms = [];
  let isAndSearch = false;

  if (lowerSearchTerm.includes(' + ') || lowerSearchTerm.includes(' and ')) {
    searchTerms = lowerSearchTerm.split(/\s*\+\s*|\s+and\s+/);
    isAndSearch = true;
  } else if (lowerSearchTerm.includes(' or ')) {
    searchTerms = lowerSearchTerm.split(/\s+or\s+/);
    isAndSearch = false;
  } else {
    searchTerms = [lowerSearchTerm];
    isAndSearch = false;
  }

  searchTerms = searchTerms.map(term => term.trim());

  return (candidateData || []).filter((candidate) => {
 const fieldMatchesTerm = (term) => {
  return [
    candidate.fullName || '',
    candidate.technicalSkill || '',
    candidate.jobRoleName || '',
    candidate.address || '',
    candidate.workAuthorizationandValidity || '',
    candidate.email || '',
     candidate.vendorName || '',
    candidate.clientStatus || '',
  ].some(field =>
    field.toLowerCase().includes(term)
  ) ||
  (candidate.experience != null && // ✅ safe check
    (
      candidate.experience.toString().toLowerCase().includes(term) ||
      `${candidate.experience} years`.toLowerCase().includes(term)
    ));
};


    return isAndSearch
      ? searchTerms.every(fieldMatchesTerm)
      : searchTerms.some(fieldMatchesTerm);
  });
}, [candidateData, searchTerm]);

const handleSelectAll = () => {
  const allFiltered = filteredCandidates.filter(
    (c) => c.email != null || c.mobileNumber != null
  );

  const allSelected = allFiltered.every((candidate) =>
    selectedCards.some(
      (selected) => getUniqueId(candidate) === getUniqueId(selected)
    )
  );

  if (allSelected) {
    // ❌ Unselect all filtered candidates
    const updated = selectedCards.filter(
      (selected) =>
        !allFiltered.some(
          (candidate) =>
            getUniqueId(candidate) === getUniqueId(selected)
        )
    );
    setSelectedCards(updated);
  } else {
    // ✅ Select all filtered candidates
    const newOnes = allFiltered.filter(
      (candidate) =>
        !selectedCards.some(
          (selected) =>
            getUniqueId(candidate) === getUniqueId(selected)
        )
    );
    setSelectedCards([...selectedCards, ...newOnes]);
  }
};


  const getUniqueId = (card) => card.email;

  const handleCardClick = (clickedCard) => {
  const clickedCardID = getUniqueId(clickedCard);

  setSelectedCards((prevSelectedCards) => {
    const isCardSelected = prevSelectedCards.some((card) => getUniqueId(card) === clickedCardID);
    let updatedSelectedCards;

    if (isCardSelected) {
      updatedSelectedCards = prevSelectedCards.filter((card) => getUniqueId(card) !== clickedCardID);
    } else {
      updatedSelectedCards = [...prevSelectedCards, clickedCard];
    }

    return updatedSelectedCards;
  });
};
const handleForwardClick = () => { 
const minimalSelected = selectedCards.map(({ fullName, email }) => ({
  fullName, email
}));
localStorage.setItem('SelectedInternalCandidates', JSON.stringify(minimalSelected));

  localStorage.setItem('cachedCandidateData', JSON.stringify(candidateData));
  localStorage.setItem('fromSendEmailPage', 'true');
  navigate(`/Employer/ViewMatchedInternalCandidates/SelectedInternalCandidatesList`);
};
  const handleViewCandidate = (data) => {
    navigate(`/Employer/ViewMatchedInternalCandidates/ViewInternalCandidateDetailsByCandidateGUid?candidateID=${data.guid}&jobPostID=${jobPostID}`)
  };

useEffect(() => {
  const allFiltered = filteredCandidates?.filter(
    (c) => c.email != null || c.mobileNumber != null
  );

  const allSelected = allFiltered.every((candidate) =>
    selectedCards.some(
      (selected) => getUniqueId(candidate) === getUniqueId(selected)
    )
  );

  setIsAllSelected(allSelected);
}, [filteredCandidates, selectedCards]);
const safeValue = (value) => 
  (value === null || value === undefined || value === "null" || value === "undefined"||value === "null..." || value === "undefined...") 
    ? "" 
    : value;

  useEffect(() => {
   const slice = filteredCandidates?.slice(offset, offset + perPage);
 setPageCount(Math.ceil(filteredCandidates.length / perPage));
    const items = viewType == 'grid' ? slice?.filter((x) => x.email != null || x.mobileNumber != null).map((data) => {
const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));

      return (
        <div className="col-sm-12 col-md-6 col-xl-6 col-lg-6 pb-3" key={data.guid}>
          <div className="card mt-2" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 650, height: 550, borderRadius: 20 }}>
            <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Full Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.fullName}</b></p>
                  </OverlayTrigger>
               
                </div>
              </div>
            </div>
            <div className="card-body" style={{ minHeight: 180 }}>
   {data.email != null && <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
                     <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-envelope" aria-hidden="true"></i>{data.email}</p>
                  </OverlayTrigger>}
               {data.mobileNumber != null && (
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Mobile Number</Tooltip>
    )}
  >
    <p style={{ fontSize: 14, display: 'flex', alignItems: 'center' }}>
      <i
        className="fas fa-phone"
        style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }}
        aria-hidden="true"
      ></i>
      {data.mobileNumber}
      <a
        href={`tel:${data.mobileNumber}`}
        title="Click to Call"
        style={{ marginLeft: 10, color: "#00a7ac" }}
      >
        <i className="fas fa-phone"></i>
      </a>
    </p>
  </OverlayTrigger>
)}

                   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Location</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {data.address} </p>
              </OverlayTrigger>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {substring_str(data.technicalSkill)} </p>
              </OverlayTrigger>
   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Experience</Tooltip>)}>
                     <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map" aria-hidden="true"></i>{data.experience}</p>
                  </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Current Visa & First US Entry</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {(data.workAuthorizationandValidity)} </p>
              </OverlayTrigger>
                 
                 {/* <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Name - Company Name</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i>  {data.vendorName} {data.vendorCompanyName? ` - ${data.vendorCompanyName}` : ""} </p>
              </OverlayTrigger>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Client Status</Tooltip>)}>
                <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fas fa-map-marker" aria-hidden="true"></i> {(data.clientStatus)} </p>
              </OverlayTrigger>
             <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> <span
        dangerouslySetInnerHTML={{
          __html: safeValue(data.comments)
        }}
      /></Tooltip>)}>
                     <p className="text-para">
      <i className="fa fa-building icons"></i>
      <span
        dangerouslySetInnerHTML={{
          __html: safeValue(substring_str(data.comments))
        }}
      />
    </p>
                  </OverlayTrigger> */}
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>LinkedinUrl</Tooltip>)}>
              <a 
            href={data.linkedinUrl?.startsWith('http') ? data.linkedinUrl : `https://${data.linkedinUrl}`} 
            target="_blank" 
            rel="noopener noreferrer"
        > <p style={{ fontSize: 14 }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-graduation-cap" aria-hidden="true"></i> {data.linkedinUrl}</p>
             </a> 
              </OverlayTrigger>
            </div>
          <div className='card-footer d-flex justify-content-between' style={{ background: "none" }}>
               <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">View</Tooltip>}>
                  <Link style={{ }} to={`/Employer/ViewMatchedInternalCandidates/ViewInternalCandidateDetailsByCandidateGUid?candidateID=${data.guid}&jobPostID=${jobPostID}`}>
              <button style={{ background: "none", border: "none" }}>

                <i className="fa fa-eye mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
              </button>
              </Link>
            </OverlayTrigger>
                {data.email &&  <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">Select to Send Email/ Save</Tooltip>}>
                    <input type="checkbox" checked={isChecked} onChange={() => handleCardClick(data)} />
                  </OverlayTrigger>
                 }
                </div>
          </div>
        </div>
      );
    }) :

      <div className="col-12 mt-2" style={{ overflowX: "auto", width: "100%" }}>
        <table className="table" style={{ minWidth: "100%", fontSize: 14 }}>
          <thead>
            <tr>
              <th>Full Name</th>
               <th>Email</th>
                <th>Mobile Number</th>
                 <th>Location</th>
                 <th style={{minWidth:100}}>Technical Skills</th>
                  <th>Experience</th>
              <th>Current Visa & First US Entry</th>
              {/* <th style={{minWidth:100}}>Client Name - Company Name</th>
              <th style={{minWidth:100}}>Client Status</th>
              <th style={{minWidth:100}}>Comments</th> */}
               <th>LinkedIn Url</th>
               <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {slice?.filter((x) => x.email != null || x.mobileNumber != null).map((data, index) => {
         const isChecked = selectedCards.some(item => getUniqueId(item) === getUniqueId(data));
              console.log("isChekd", isChecked)
              return (
                <tr key={index}>
                  <td>{data.fullName}</td>
                  <td style={{ maxWidth: 200, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}>{data.email}</td>
                 <td>
  {data.mobileNumber ? (
    <>
      {data.mobileNumber}
      <a
        href={`tel:${data.mobileNumber}`}
        style={{ marginLeft: 8, color: '#00a7ac' }}
        title="Click to Call"
      >
        <i className="fas fa-phone"></i>
      </a>
    </>
  ) : (
    "N/A"
  )}
</td>

                  <td>{data.address}</td>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.technicalSkill}</Tooltip>)}>
                  <td>{substring_str(data.technicalSkill)}</td>
                  </OverlayTrigger>
                   <td>{data.experience}</td>
                 
                   <td>{data.workAuthorizationandValidity}</td>
                   {/* <td> {data.vendorName} {data.vendorCompanyName? ` - ${data.vendorCompanyName}` : ""}</td>
                   <td>{data.clientStatus}</td>
                   <OverlayTrigger
          placement="bottom"
          overlay={(props) => (
            <Tooltip id="tooltip" {...props}>
           <span  dangerouslySetInnerHTML={{ __html: safeValue(data.comments) }}></span>
            </Tooltip>
          )}
        >
     <td dangerouslySetInnerHTML={{ __html: safeValue(substring_str(data.comments)) }}></td>
        </OverlayTrigger> */}
            <td style={{ maxWidth: 150, wordWrap: "break-word", wordBreak: "break-word", overflowWrap: "break-word" }}> 
  {data.linkedinUrl && data.linkedinUrl !== "null" && (
    <a
      href={data.linkedinUrl.startsWith('http') ? data.linkedinUrl : `https://${data.linkedinUrl}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#00a7ac", textDecoration: "underline" }}
    >
      {data.linkedinUrl}
    </a>
  )}
</td>

                  <td>
                    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
   <OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">View</Tooltip>}>
                     <Link style={{ }} to={`/Employer/ViewMatchedInternalCandidates/ViewInternalCandidateDetailsByCandidateGUid?candidateID=${data.guid}&jobPostID=${jobPostID}`}>
  <button  style={{ background: "none", border: "none" }}>
    <i className="fa fa-eye mt-1" aria-hidden="true" style={{ fontSize: 20, color: "#00a7ac" }}></i>
  </button>
  </Link>
</OverlayTrigger>
          {data.email && (
  <OverlayTrigger
    placement="bottom"
    overlay={<Tooltip id="tooltip">Select to Send Email/ Save</Tooltip>}
  >
    <input
      type="checkbox"
      checked={isChecked}
      onChange={() => handleCardClick(data)}
    />
  </OverlayTrigger>
)}


                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>


    setData(items);
    setPageCount(Math.ceil(filteredCandidates.length / perPage));
    
  }, [offset, searchTerm, startDate, endDate, candidateData, perPage, viewType, selectedCards]);

  return (
    <ConsultantLayout>
      <div className='container-fluid mt-3'>
 <div class="responsive-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Link to="/Employer/ListOfJobPosts">
              <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8 }} aria-hidden="true"></i>
            </Link>
            <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>View Matched Candidates</h2>
          </div>
               {showIcon === 'grid' && (
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleViewToggle('list')}
                                                style={{ backgroundColor: "#00a7ac" }}
                                              >
                                                <i className="fa fa-th-list" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                              </button>
                                            </OverlayTrigger>
                                          )}
                                          {showIcon === 'list' && (
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                                              <button
                                                className="btn btn-primary"
                                                onClick={() => handleViewToggle('grid')}
                                                style={{ backgroundColor: "#00a7ac" }}
                                              >
                                                <i className="fa fa-th" style={{ color: '#fff', cursor: 'pointer' }}></i>
                                              </button>
                                            </OverlayTrigger>
                                          )}
         </div>
        <div>

        </div>
<div className="col">
  <OverlayTrigger
    placement="bottom"
    overlay={(props) => (
      <Tooltip id="tooltip" {...props}>Search by Name or Technical Skill or Email or Role or Address or Work Authorization or Client Name or Client Status (Ex: AWS and Amazon S3)</Tooltip>
    )}
  >
    <input
      type="text"
      placeholder="Search by Name or Technical Skill or Email or Role or Address or Work Authorization or Client Name or Client Status (Ex: AWS and Amazon S3)"
      className="form-control mt-3"
      id="searchcss2"
      value={searchTerm}
      onChange={handleSearch}
    />
  </OverlayTrigger>
</div>

        <hr />
     <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '20px' }}>

         <div style={{ textAlign: 'right',marginLeft:8 }}>
               <OverlayTrigger placement="bottom" overlay={<Tooltip>Select All</Tooltip>}>
             <label style={{ marginBottom: 0 }}>
    <input
      type="checkbox"
      checked={isAllSelected}
      onChange={handleSelectAll}
      style={{ marginRight: 5 }}
    />
    Select All
  </label>
 </OverlayTrigger>
  </div>

                      {selectedCards.length > 0 && selectedCards.some(item => item.email) && (
  <div style={{ textAlign: 'right' }}>
                   <OverlayTrigger placement="bottom" overlay={<Tooltip>Send Email</Tooltip>}>

    <button className="btn btn-primary" onClick={handleForwardClick}  style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: "8px", width: 'auto', height: "45px",
    display: "flex",alignItems: "center", justifyContent: "center", marginLeft: "8px"  }}>
      <i className="fa fa-arrow-right mr-1"></i> Send Email
    </button>
    </OverlayTrigger>
  </div>
)}
</div>
        <div className="row mt-3 pb-3">
                   {isLoading ? <center><LoadingSpinner /></center> : <>
            <div>

            </div>

            {data}
          </>}
        </div>
   {!isLoading && filteredCandidates.length === 0 && (
  <div className="pb-5 text-center">
    <img title="No Data" className="no-data-img" src={nodataimg} style={{ height: 350 }} />
    <p style={{ color: '#888' }}>No candidates found.</p>
  </div>
)}


              {
          candidateData.length > perPage &&
          <ReactPaginate
            previousLabel={"Prev"}
            nextLabel={"Next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            disabledClassName={"disable-pagination-button"}
          />
        }

      </div>
    </ConsultantLayout>
  );
}

export default ViewMatchedInternalCandidates;


